import React from "react";
import moment from "moment-timezone";

//REDUX
import reduxStore from "store/";

//COMPONENTS
import Card from "components/Card";
import Button from "@material-ui/core/Button";
import Icon from "components/Icon";

//IMAGES
import userCover from "assets/img/userCover.jpg"

//FUNCTIONS
import {
    customApp,
    translate
} from "functions/";

function DayList(props) {
    const { session } = reduxStore.getState()
    const { data } = props
    const today = moment().tz('America/Sao_Paulo').format('YYYY/MM/DD');
    const [ImagePreview, setImagePreview] = React.useState(null)

    let myCards = Object.keys(reduxStore.getState().db.cards).filter(a => reduxStore.getState().db.cards[a]).map(c => reduxStore.getState().db.cards[c])

    let myDayTasksContent = myCards.filter(a =>
        a._users
        && !a.checklist
        && !a.deleted
        && a._users[data._id]
        && a._users[data._id].myDay
        && (
            !a.private
            ||
            (
                a.private
                && a._users[session._id]
            )
        )
        && (
            moment(new Date(parseInt(a._users[data._id].myDay) * 1000)).tz('America/Sao_Paulo').format('YYYY/MM/DD') === today
        )
    ).sort((a, b) => {
        if (reduxStore.getState().db.orderByTitle
            && reduxStore.getState().db.orderByTitlePosition === 'ASC'
            && a.name.toLowerCase().trim() < b.name.toLowerCase().trim()
        ) {
            return -1
        } else if (reduxStore.getState().db.orderByTitle
            && reduxStore.getState().db.orderByTitlePosition === 'DESC'
            && a.name.toLowerCase().trim() > b.name.toLowerCase().trim()
        ) {
            return -1
        } else if (reduxStore.getState().db.orderByTitle) {
            return 0
        } else if (!reduxStore.getState().db.orderByTitle && String(a.order) && String(b.order) && String(a.order.low) && String(b.order.low) && parseInt(a.order.low) < parseInt(b.order.low)) {
            return -1
        } else {
            return 1
        }
    }).map((a, i) => (
        // MUDANÇA: Layout idêntico às sugestões
        <div
            style={{
                width: "calc(100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "4px" // Menor espaçamento como nas sugestões
            }}
            key={a._id || i}
        >
            <Card db="cards" data={a} noShadow />
            <Button
                onClick={() => {
                    // Ação para marcar como concluído ou remover do dia
                    console.log('Ação no card:', a._id);
                    // Aqui você pode implementar a lógica para:
                    // - Marcar como concluído
                    // - Remover do "Meu Dia"
                    // - Outras ações
                }}
            >
                <Icon
                    icon="check_circle"
                    color={customApp("menu")}
                    title={translate("$__markAsCompleted", 1)}
                />
            </Button>
        </div>
    ))

    return (
        <div style={{
            width: "100%",
            minHeight: "120px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0 0 9px 3px rgba(0,0,0,0.2)",
            position: "relative",
        }}>
            <div
                style={{
                    backgroundColor: customApp('menu'),
                    height: "43px",
                    paddingLeft: "45px",
                    fontSize: "12px",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                <div style={{
                    maxWidth: 'calc(100% - 10px)',
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                }}>
                    {data.name} ({myDayTasksContent.length})
                </div>
            </div>

            {/* Avatar do usuário */}
            {(!ImagePreview || (data.image && data.image !== ImagePreview)) ?
                <img
                    style={{
                        width: "37px",
                        height: "37px",
                        top: "3px",
                        left: "3px",
                        borderRadius: '50%',
                        border: `solid 2px ${customApp('color')}`,
                        zIndex: '5 !important',
                        position: 'absolute',
                        backgroundColor: `${customApp('color')}`,
                    }}
                    src={`${data.image ? data.image : userCover}`}
                    onError={(e) => {
                        e.target.src = `${userCover}`
                    }}
                    onLoad={(e) => {
                        setImagePreview(`${data.image ? data.image : userCover}`)
                    }}
                    width="100%"
                    alt="MACHEN_IMG"
                />
                :
                <div
                    style={{
                        width: "37px",
                        height: "37px",
                        top: "3px",
                        left: "3px",
                        borderRadius: '50%',
                        border: `solid 2px ${customApp('color')}`,
                        zIndex: '5 !important',
                        position: 'absolute',
                        backgroundColor: `${customApp('color')}`,
                        backgroundImage: `url("${ImagePreview}")`,
                        backgroundSize: "cover",
                        backgroundPosition: "center center"
                    }}
                />
            }

            {/* Container das tarefas */}
            <div style={{
                width: '100%',
                maxHeight: 'calc(50vh - 90px)',
                overflowY: 'auto',
                padding: "8px 4px" // Padding ajustado para ficar similar às sugestões
            }}>
                {myDayTasksContent}
            </div>
        </div>
    );
}

//EXPORT
export default DayList